import React from 'react';

import './privacy.scss';

interface PrivacyProps {
}

const Privacy: React.FC<PrivacyProps> = (props: PrivacyProps) => {
  return (
    <section className="component-privacy" data-aos="fade-in" data-aos-delay={50}>
      <h2>Privacy Policy</h2>

      <p>This privacy policy applies between you, the User of this Website and Bedican Ltd, the owner and provider of this Website. Bedican Ltd takes the privacy of your information very seriously. This privacy policy applies to our use of any and all Data collected by us or provided by you in relation to your use of the Website.</p>
      <p>Please read this privacy policy carefully.</p>

      <h3>Definitions and interpretation</h3>

      <ol>
        <li>
          <p>In this privacy policy, the following definitions are used:</p>
          <div className="definitions">
            <div className="row">
              <div className="col-12 col-sm-4 col-md-3 col-lg-3 col-xl-2">Data</div>
              <div className="col-12 col-sm-8 col-md-9 col-lg-9 col-xl-10">
                collectively all information that you submit to Bedican Ltd via the Website. This definition incorporates, where applicable, the definitions provided in the Data Protection Laws;
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-sm-4 col-md-3 col-lg-3 col-xl-2">Cookies</div>
              <div className="col-12 col-sm-8 col-md-9 col-lg-9 col-xl-10">
                a small text file placed on your computer by this Website when you visit certain parts of the Website and/or when you use certain features of the Website. Details of the cookies used by this Website are set out in the clause below (Cookies);
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-sm-4 col-md-3 col-lg-3 col-xl-2">Data Protection Laws</div>
              <div className="col-12 col-sm-8 col-md-9 col-lg-9 col-xl-10">
                any applicable law relating to the processing of personal Data, including but not limited to the Directive 96/46/EC (Data Protection Directive) or the GDPR, and any national implementing laws, regulations and secondary legislation, for as long as the GDPR is effective in the UK;
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-sm-4 col-md-3 col-lg-3 col-xl-2">GDPR</div>
              <div className="col-12 col-sm-8 col-md-9 col-lg-9 col-xl-10">the General Data Protection Regulation (EU) 2016/679;</div>
            </div>
            <div className="row">
              <div className="col-12 col-sm-4 col-md-3 col-lg-3 col-xl-2">Bedican Ltd, we or us</div>
              <div className="col-12 col-sm-8 col-md-9 col-lg-9 col-xl-10">
                Bedican Ltd, a company incorporated in England and Wales with registered number 08704088;
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-sm-4 col-md-3 col-lg-3 col-xl-2">UK and EU Cookie Law</div>
              <div className="col-12 col-sm-8 col-md-9 col-lg-9 col-xl-10">
                the Privacy and Electronic Communications (EC Directive) Regulations 2003 as amended by the Privacy and Electronxic Communications (EC Directive) (Amendment) Regulations 2011;
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-sm-4 col-md-3 col-lg-3 col-xl-2">User or you</div>
              <div className="col-12 col-sm-8 col-md-9 col-lg-9 col-xl-10">
                any third party that accesses the Website and is not either (i) employed by Bedican Ltd and acting in the course of their employment or (ii) engaged as a consultant or otherwise providing services to Bedican Ltd and accessing the Website in connection with the provision of such services;
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-sm-4 col-md-3 col-lg-3 col-xl-2">Website</div>
              <div className="col-12 col-sm-8 col-md-9 col-lg-9 col-xl-10">
                the website that you are currently using, www.bedican.co.uk, and any sub-domains of this site unless expressly excluded by their own terms and conditions.
              </div>
            </div>
          </div>
        </li>
        <li>
          <p>In this privacy policy, unless the context requires a different interpretation:</p>
          <ol>
            <li>the singular includes the plural and vice versa;</li>
            <li>references to sub-clauses, clauses, schedules or appendices are to sub-clauses, clauses, schedules or appendices of this privacy policy;</li>
            <li>a reference to a person includes firms, companies, government entities, trusts and partnerships;</li>
            <li>"including" is understood to mean "including without limitation";</li>
            <li>reference to any statutory provision includes any modification or amendment of it;</li>
            <li>the headings and sub-headings do not form part of this privacy policy.</li>
          </ol>
        </li>
      </ol>

      <h3>Scope of this privacy policy</h3>

      <ol>
        <li>This privacy policy applies only to the actions of Bedican Ltd and Users with respect to this Website. It does not extend to any websites that can be accessed from this Website including, but not limited to, any links we may provide to social media websites.</li>
        <li>For purposes of the applicable Data Protection Laws, Bedican Ltd is the "data controller". This means that Bedican Ltd determines the purposes for which, and the manner in which, your Data is processed.</li>
      </ol>

      <h3>Data collected</h3>

      <ol>
        <li>
          <p>We may collect the following Data, which includes personal Data, from you:</p>
          <ol>
            <li>name;</li>
            <li>contact Information such as email addresses and telephone numbers;</li>
            <li>demographic information such as postcode, preferences and interests;</li>
            <li>IP address (automatically collected);</li>
            <li>web browser type and version (automatically collected);</li>
            <li>a list of URLs starting with a referring site, your activity on this Website, and the site you exit to (automatically collected); in each case, in accordance with this privacy policy.</li>
          </ol>
        </li>
      </ol>

      <h3>How we collect Data</h3>

      <ol>
        <li>
          <p>We collect Data in the following ways:</p>
          <ol>
            <li>data is given to us by you; and</li>
            <li>data is collected automatically.</li>
          </ol>
        </li>
      </ol>

      <h3>Data that is given to us by you</h3>

      <ol>
        <li>
          <p>Bedican Ltd will collect your Data in a number of ways, for example:</p>
          <ol>
            <li>when you contact us through the Website, by telephone, post, e-mail or through any other means;</li>
            <li>when you make payments to us, through this Website or otherwise;</li>
            <li>when you elect to receive marketing communications from us;</li>
            <li>when you use our services;</li>
          </ol>
          <p>in each case, in accordance with this privacy policy.</p>
        </li>
      </ol>

      <h3>Data that is collected automatically</h3>

      <ol>
        <li>
          <p>To the extent that you access the Website, we will collect your Data automatically, for example:</p>
          <ol>
            <li>we automatically collect some information about your visit to the Website. This information helps us to make improvements to Website content and navigation, and includes your IP address, the date, times and frequency with which you access the Website and the way you use and interact with its content.</li>
            <li>we will collect your Data automatically via cookies, in line with the cookie settings on your browser. For more information about cookies, and how we use them on the Website, see the section below, headed "Cookies"</li>
          </ol>
        </li>
      </ol>

      <h3>Our use of Data</h3>

      <ol>
        <li>
          <p>Any or all of the above Data may be required by us from time to time in order to provide you with the best possible service and experience when using our Website. Specifically, Data may be used by us for the following reasons:</p>
          <ol>
            <li>internal record keeping;</li>
            <li>improvement of our products / services;</li>
            <li>transmission by email of marketing materials that may be of interest to you;</li>
            <li>contact for market research purposes which may be done using email, telephone, fax or mail. Such information may be used to customise or update the Website;</li>
          </ol>
          <p>in each case, in accordance with this privacy policy.</p>
        </li>
        <li>
          We may use your Data for the above purposes if we deem it necessary to do so for our legitimate interests. If you are not satisfied with this, you have the right to object in certain circumstances (see the section headed "Your rights" below).
        </li>
        <li>
          <p>For the delivery of direct marketing to you via e-mail, we'll need your consent, whether via an opt-in or soft-opt-in:</p>
          <ol>
            <li>soft opt-in consent is a specific type of consent which applies when you have previously engaged with us (for example, you contact us to ask us for more details about a particular product/service, and we are marketing similar products/services). Under "soft opt-in" consent, we will take your consent as given unless you opt-out.</li>
            <li>for other types of e-marketing, we are required to obtain your explicit consent; that is, you need to take positive and affirmative action when consenting by, for example, checking a tick box that we'll provide.</li>
            <li>if you are not satisfied about our approach to marketing, you have the right to withdraw consent at any time. To find out how to withdraw your consent, see the section headed "Your rights" below.</li>
          </ol>
        </li>
      </ol>

      <h3>Who we share Data with</h3>

      <ol>
        <li>
          <p>We may share your Data with the following groups of people for the following reasons:</p>
          <ol>
            <li>our employees, agents and/or professional advisors in each case, in accordance with this privacy policy.</li>
          </ol>
        </li>
      </ol>

      <h3>Keeping Data secure</h3>

      <ol>
        <li>
          <p>We will use technical and organisational measures to safeguard your Data, for example:</p>
          <ol>
            <li>access to your account is controlled by a password and a user name that is unique to you.</li>
            <li>we store your Data on secure servers.</li>
          </ol>
        </li>
        <li>
          Technical and organisational measures include measures to deal with any suspected data breach. If you suspect any misuse or loss or unauthorised access to your Data, please let us know immediately by contacting us via this e-mail address: <a href="mailto:contact@bedican.co.uk">contact@bedican.co.uk</a>.
        </li>
        <li>
          If you want detailed information from Get Safe Online on how to protect your information and your computers and devices against fraud, identity theft, viruses and many other online problems, please visit www.getsafeonline.org. Get Safe Online is supported by HM Government and leading businesses.
        </li>
      </ol>

      <h3>Data retention</h3>

      <ol>
        <li>
          Unless a longer retention period is required or permitted by law, we will only hold your Data on our systems for the period necessary to fulfil the purposes outlined in this privacy policy or until you request that the Data be deleted.
        </li>
        <li>
          Even if we delete your Data, it may persist on backup or archival media for legal, tax or regulatory purposes.
        </li>
      </ol>

      <h3>Your rights</h3>

      <ol>
        <li>
          <p>You have the following rights in relation to your Data:</p>
          <ol>
            <li><b>Right to access</b> - the right to request (i) copies of the information we hold about you at any time, or (ii) that we modify, update or delete such information. If we provide you with access to the information we hold about you, we will not charge you for this, unless your request is "manifestly unfounded or excessive." Where we are legally permitted to do so, we may refuse your request. If we refuse your request, we will tell you the reasons why.</li>
            <li><b>Right to correct</b> - the right to have your Data rectified if it is inaccurate or incomplete.</li>
            <li><b>Right to erase</b> - the right to request that we delete or remove your Data from our systems.</li>
            <li><b>Right to restrict our use of your Data</b> - the right to "block" us from using your Data or limit the way in which we can use it.</li>
            <li><b>Right to data portability</b> - the right to request that we move, copy or transfer your Data.</li>
            <li><b>Right to object</b> - the right to object to our use of your Data including where we use it for our legitimate interests.</li>
          </ol>
        </li>
        <li>
          To make enquiries, exercise any of your rights set out above, or withdraw your consent to the processing of your Data (where consent is our legal basis for processing your Data), please contact us via this e-mail address: <a href="mailto:contact@bedican.co.uk">contact@bedican.co.uk</a>.
        </li>
        <li>
          If you are not satisfied with the way a complaint you make in relation to your Data is handled by us, you may be able to refer your complaint to the relevant data protection authority. For the UK, this is the Information Commissioner's Office (ICO). The ICO's contact details can be found on their website at https://ico.org.uk/.
        </li>
        <li>
          It is important that the Data we hold about you is accurate and current. Please keep us informed if your Data changes during the period for which we hold it.
        </li>
      </ol>

      <h3>Links to other websites</h3>

      <ol>
        <li>
          This Website may, from time to time, provide links to other websites. We have no control over such websites and are not responsible for the content of these websites. This privacy policy does not extend to your use of such websites. You are advised to read the privacy policy or statement of other websites prior to using them.
        </li>
      </ol>

      <h3>Changes of business ownership and control</h3>

      <ol>
        <li>
          Bedican Ltd may, from time to time, expand or reduce our business and this may involve the sale and/or the transfer of control of all or part of Bedican Ltd. Data provided by Users will, where it is relevant to any part of our business so transferred, be transferred along with that part and the new owner or newly controlling party will, under the terms of this privacy policy, be permitted to use the Data for the purposes for which it was originally supplied to us.
        </li>
        <li>
          We may also disclose Data to a prospective purchaser of our business or any part of it.
        </li>
        <li>
          In the above instances, we will take steps with the aim of ensuring your privacy is protected.
        </li>
      </ol>

      <h3>Cookies</h3>

      <ol>
        <li>
          This Website may place and access certain Cookies on your computer. Bedican Ltd uses Cookies to improve your experience of using the Website and to improve our range of services. Bedican Ltd has carefully chosen these Cookies and has taken steps to ensure that your privacy is protected and respected at all times.
        </li>
        <li>
          All Cookies used by this Website are used in accordance with current UK and EU Cookie Law.
        </li>
        <li>
          Before the Website places Cookies on your computer, you will be presented with a message bar requesting your consent to set those Cookies. By giving your consent to the placing of Cookies, you are enabling Bedican Ltd to provide a better experience and service to you. You may, if you wish, deny consent to the placing of Cookies; however certain features of the Website may not function fully or as intended.
        </li>
        <li>
          <p>This Website may place the following Cookies:</p>
          <ol>
            <li><b>Strictly necessary cookies</b> - These are cookies that are required for the operation of our website. They include, for example, cookies that enable you to log into secure areas of our website, use a shopping cart or make use of e-billing services.</li>
            <li><b>Analytical/performance cookies</b> - They allow us to recognise and count the number of visitors and to see how visitors move around our website when they are using it. This helps us to improve the way our website works, for example, by ensuring that users are finding what they are looking for easily.</li>
          </ol>
        </li>
        <li>
          You can choose to enable or disable Cookies in your internet browser. By default, most internet browsers accept Cookies but this can be changed. For further details, please consult the help menu in your internet browser.
        </li>
        <li>
          You can choose to delete Cookies at any time; however you may lose any information that enables you to access the Website more quickly and efficiently including, but not limited to, personalisation settings.
        </li>
        <li>
          It is recommended that you ensure that your internet browser is up-to-date and that you consult the help and guidance provided by the developer of your internet browser if you are unsure about adjusting your privacy settings.
        </li>
        <li>
          For more information generally on cookies, including how to disable them, please refer to aboutcookies.org. You will also find details on how to delete cookies from your computer.
        </li>
      </ol>

      <h3>General</h3>

      <ol>
        <li>
          You may not transfer any of your rights under this privacy policy to any other person. We may transfer our rights under this privacy policy where we reasonably believe your rights will not be affected.
        </li>
        <li>
          If any court or competent authority finds that any provision of this privacy policy (or part of any provision) is invalid, illegal or unenforceable, that provision or part-provision will, to the extent required, be deemed to be deleted, and the validity and enforceability of the other provisions of this privacy policy will not be affected.
        </li>
        <li>
          Unless otherwise agreed, no delay, act or omission by a party in exercising any right or remedy will be deemed a waiver of that, or any other, right or remedy.
        </li>
        <li>
          This Agreement will be governed by and interpreted according to the law of England and Wales. All disputes arising under the Agreement will be subject to the exclusive jurisdiction of the English and Welsh courts.
        </li>
      </ol>

      <h3>Changes to this privacy policy</h3>

      <ol>
        <li>
          Bedican Ltd reserves the right to change this privacy policy as we may deem necessary from time to time or as may be required by law. Any changes will be immediately posted on the Website and you are deemed to have accepted the terms of the privacy policy on your first use of the Website following the alterations.
        </li>
      </ol>

      <p>You may contact Bedican Ltd by email at <a href="mailto:contact@bedican.co.uk">contact@bedican.co.uk</a>.</p>

    </section>
  );
};

export default Privacy;